module.exports = __webpack_public_path__ + "static/dating-design-04-c6aa97797d10ece877626f0d78e26c87.jpg";